import { render } from "./Picking.vue?vue&type=template&id=3817aa74"
import script from "./Picking.vue?vue&type=script&lang=js"
export * from "./Picking.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__